import React, { useState, useEffect } from 'react';
import { Container, Typography, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Box, CircularProgress } from '@mui/material';
import { Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const ClientList = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const token = localStorage.getItem('token');
        
        const response = await axios.get('/api/clients', {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        if (response.data.status === 'success') {
          setClients(response.data.data.clients);
        }
        
        setLoading(false);
      } catch (error) {
        console.error('Error fetching clients:', error);
        setError('Erro ao carregar clientes. Por favor, tente novamente.');
        setLoading(false);
        
        if (error.response && error.response.status === 401) {
          navigate('/login');
        }
      }
    };
    
    fetchClients();
  }, [navigate]);

  const handleAddClient = () => {
    navigate('/clients/new');
  };

  const handleEditClient = (clientId) => {
    navigate(`/clients/${clientId}`);
  };

  const handleDeleteClient = async (clientId) => {
    if (window.confirm('Tem certeza que deseja excluir este cliente?')) {
      try {
        const token = localStorage.getItem('token');
        
        await axios.delete(`/api/clients/${clientId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        // Atualizar a lista de clientes após exclusão
        setClients(clients.filter(client => client._id !== clientId));
      } catch (error) {
        console.error('Error deleting client:', error);
        alert('Erro ao excluir cliente. Por favor, tente novamente.');
      }
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4">Clientes</Typography>
        <Button 
          variant="contained" 
          startIcon={<AddIcon />}
          onClick={handleAddClient}
        >
          Novo Cliente
        </Button>
      </Box>
      
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Paper sx={{ p: 3, textAlign: 'center' }}>
          <Typography color="error">{error}</Typography>
        </Paper>
      ) : clients.length === 0 ? (
        <Paper sx={{ p: 5, textAlign: 'center' }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Nenhum cliente cadastrado
          </Typography>
          <Typography sx={{ mb: 3 }}>
            Adicione seu primeiro cliente para começar a usar o Tilti BI.
          </Typography>
          <Button 
            variant="contained" 
            startIcon={<AddIcon />}
            onClick={handleAddClient}
          >
            Adicionar Cliente
          </Button>
        </Paper>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Nome</TableCell>
                <TableCell>Website</TableCell>
                <TableCell>Data de Criação</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="right">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {clients.map((client) => (
                <TableRow key={client._id}>
                  <TableCell component="th" scope="row">
                    {client.name}
                  </TableCell>
                  <TableCell>{client.website || '-'}</TableCell>
                  <TableCell>
                    {new Date(client.createdAt).toLocaleDateString('pt-BR')}
                  </TableCell>
                  <TableCell>
                    <Box 
                      component="span" 
                      sx={{ 
                        py: 0.5, 
                        px: 1.5, 
                        borderRadius: 1,
                        bgcolor: client.active ? 'success.light' : 'error.light',
                        color: 'white'
                      }}
                    >
                      {client.active ? 'Ativo' : 'Inativo'}
                    </Box>
                  </TableCell>
                  <TableCell align="right">
                    <IconButton 
                      color="primary" 
                      onClick={() => handleEditClient(client._id)}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton 
                      color="error" 
                      onClick={() => handleDeleteClient(client._id)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Container>
  );
};

export default ClientList;
